var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_c('footer',[_c('div',{staticClass:"footer-item"},[_vm._v("2022© Brins Studio All Rights Resaved")])])])
}]

export { render, staticRenderFns }